export const TOKEN_KEY = 'token';
export const IS_ADMIN_KEY = 'is_admin';
export const USER_INFO_KEY = 'user_info';
export const READ_ANNOUNCEMENTS_KEY = 'read_announcements';
/** 是否强制修改密码：'0' 表示必须修改，'1' 表示正常使用 */
export const FORCE_UPDATE_PASSWORD_KEY = 'force_update_password';

/** 登录页「记住」的账号，仅用于下次自动回填 */
export const LOGIN_USERNAME_KEY = 'login_username';
/** 登录页「记住」的密码，仅用于下次自动回填（本地明文，注意安全） */
export const LOGIN_PWD_KEY = 'login_pwd';
//埋点用户唯一标识
export const ET_DISTINCT_ID = 'et_distinct_id'

export const LOCAL_STORAGE_KEYS = {
  TOKEN: TOKEN_KEY,
  IS_ADMIN: IS_ADMIN_KEY,
  USER_INFO: USER_INFO_KEY,
  LOGIN_USERNAME: LOGIN_USERNAME_KEY,
  LOGIN_PWD: LOGIN_PWD_KEY,
  READ_ANNOUNCEMENTS: READ_ANNOUNCEMENTS_KEY,
  FORCE_UPDATE_PASSWORD: FORCE_UPDATE_PASSWORD_KEY,
};